module.exports = __webpack_public_path__ + "img/Trophy Cup Table00.f99d9ac9.jpg";